export const ENDPOINT_CSS_API =
  process.env.ENDPOINT_CSS_API ?? 'https://api.tuicruises.com/cruisesearch/v3';
